export default "__VITE_ASSET__EaJvN$Dw__"